import { computed, defineComponent, ref } from 'vue';
import { useStore } from 'vuex';
import { ProcureGetter } from '@/store/procure/procure.module';
import { Procure, ProcureAttachment } from '@/store/procure/procure.model';
import BaseOffcanvasComponent from '@/components/baseOffcanvas/BaseOffcanvas.vue';

export default defineComponent({
  name: 'ProjectProcureAttachmentOffcanvasComponent',
  components: {
    BaseOffcanvasComponent
  },
  props: {
    projectId: {
      type: Number
    }
  },
  setup: () => {
    const store = useStore();
    const procure = computed<Procure | undefined>(() => store.getters[ProcureGetter.GET]);
    const attachments = computed<ProcureAttachment[]>(() => (procure.value) ? procure.value?.attachments.filter(m => m.attachmentType.id === 1) : []);
    const images = computed<ProcureAttachment[]>(() => (procure.value) ? procure.value?.attachments.filter(m => m.attachmentType.id === 2) : []);
    const attachmentOffcanvas = ref<InstanceType<typeof BaseOffcanvasComponent>>();

    // show modal
    const show = () => {
      attachmentOffcanvas.value?.show();
    };

    // hide modal
    const hide = () => {
      attachmentOffcanvas.value?.hide();
    };

    const attachmentClick = (url: string) => {
      window.open(url, '_blank');
    };

    return {
      attachments,
      images,
      attachmentOffcanvas,
      show,
      hide,
      attachmentClick,
    };
  }
});
